<template>
  <div style="margin-top:30px">
    <tabla  Titulo="Tipo de Vestido" :Cabecera="Cabecera" :Items="Items" :Excel="false" :Crear="true" />
  </div>
</template>
<script>
import tabla from "@/components/tipoproducto/tabla.vue"
import { mapGetters, mapActions } from "vuex";
export default {
  name: "TipoProducto",
  components : {
    tabla
  },
  created(){
    const data = {menu1:-1,menu2:2,submenu2:0,menu3:0,submenu3:0};
    this.CargarMenu(data);
    this.cargarTipoProducto();
  },
  data(){
    return{
      Cabecera:[
        {text:'Id',value:'id'},
        {text:'Nombre',value:'TIP_Nombre'},
        {text:'Accion',value:'Accion'}
      ]
    }
  },
  methods:{
    ...mapActions('tipoproducto',['cargarTipoProducto']),
    ...mapActions('nav',['CargarMenu'])
  },

  computed:{
    ...mapGetters('tipoproducto',['Items'])    
  }


};
</script>




